import styles from './Segmented.module.css';

/**
 * Pill-shaped segmented control — the language switcher and the 7d/30d/all-time
 * range picker both use this.
 *
 * options: [{ value, label }]
 * value:   currently selected value
 * size:    'sm' (topbar) | 'md' (default)
 */
export function Segmented({ options, value, onChange, size = 'md', ariaLabel, className = '' }) {
  return (
    <div
      className={`${styles.seg} ${size === 'sm' ? styles.sm : ''} ${className}`}
      role="tablist"
      aria-label={ariaLabel}
    >
      {options.map((opt) => (
        <button
          key={opt.value}
          type="button"
          role="tab"
          aria-selected={opt.value === value}
          className={opt.value === value ? styles.on : ''}
          onClick={() => onChange?.(opt.value)}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}
